// eslint-disable-next-line import/prefer-default-export
export const DND_TYPE_PAGE_CONFIG = 'page-config-widget';
export const PREVIEW_NAMESPACE = 'do/Page/preview.action';
